import { Chip } from "@mui/material";
import {
  Get_Active_Workflow_With_Leads,
  Get_Active_Workflows_Activity,
  Get_Appointment_Scheduled,
  Get_Avg_Email_Open_Rate,
  Get_Avg_Lead_Response_Time,
  Get_Email_Conversations_OverTime,
  Get_Email_Received,
  Get_Email_Sent,
  Get_Lead_Lists_In_Workflows,
  Get_Leads_By_Location,
  Get_Leads_Contacted_By_Team_Member,
  Get_Leads_Generated,
  Get_Leads_Not_Contacted,
  Get_Mql_Leads_By_First_Outreach,
  Get_SMS_Received,
  Get_SMS_Sent,
  Get_Unassigned_Leads,
  Recent_Activity_Created_Leads,
} from "../analytics/graphql-queries";
import {
  ActiveWorkflowsWithLeadsColumns,
  LeadListInWorkflowsColumns,
  LeadsNotContactedColumns,
  RecentActivityCreatedLeads,
  UnassignedLeadsColumns,
} from "../leads/constant";
import {
  getFormattedDate,
  getTimezoneAbbreviation,
  groupBy,
} from "@/services/generic.methods";
import { GraphColors } from "@/components/charts/helper";
import { ActivityTypeEnumns } from "@/services/dropdown-enums";
import moment from "moment";

export const time = {
  format: {
    default: "ddd, DD-MMM-YYYY • hh:mm A",
    date: "ddd, DD-MMM-YYYY",
    time: "hh:mm A",
    fetchDate: "ddd, DD-MMM-YYYY hh:mm A",
    isoStringFormat: "YYYY-MM-DDTHH:mm:ss.SSS[Z]",
    standardDate: "YYYY-MM-DDTHH:mm:ss",
    dateOnly: "YYYY-MM-DD",
    dateWithTime: "YYYY-MM-DD HH:mm ",
  },
};

export default {
  time,
};

export const Chart_Types = {
  bar_v_multiple: "bar_v_multiple",
  bar_h_multiple: "bar_h_multiple",
  bar_h_single: "bar_h_single",
  bar_v_single: "bar_v_single",
  line_multiple: "line_multiple",
  line_single: "line_single",
  widget: "widget",
  grid: "grid",
  pie: "pie",
};

export const ReportEnums = {
  Activity_of_recently_created_leads: 1,
  Leads_contacted_by_team_member: 2,
  Leads_generated: 3,
  MQL_leads_by_first_outreach: 4,
  Leads_by_location: 5,
  Leads_not_contacted: 6,
  Leads_lost: 7,
  Avg_lead_response_time: 8,
  Lead_lists_in_workflows: 9,
  Top_10_lists: 10,
  Avg_email_open_rate: 11,
  Email_conversations_over_time: 12,
  Email_un_subscribe_rate: 13,
  Email_bounce_rate: 14,
  SMS_Delivery_rate: 15,
  SMS_Open_rate: 16,
  Link_clicks_in_SMS: 17,
  Appointment_sent: 18,
  Appointment_booked: 19,
  Lead_to_appointment_ratio: 20,
  Leads_with_social_platforms: 21,
  Email_received: 22,
  Email_sent: 23,
  SMS_sent: 24,
  SMS_received: 25,
  Appointment_Scheduled: 26,
  Unassigned_leads: 27,
  Active_Workflows_Activity_Report: 28,
  Active_Workflows_With_Leads_Report: 29,
};

export const ReportTemplatesInfo = {
  [ReportEnums.Activity_of_recently_created_leads]: {
    categoryIds: [1],
    query: Recent_Activity_Created_Leads,
    dataKey: "recentActivityCreatedLeads",
    defaultSortKey: "leadId",
    name: "Activity Of Recently Created Leads",
    desc: "Data Table - Lead, Create date, deal stage",
    isKPI: false,
    type: Chart_Types.grid,
    columns: RecentActivityCreatedLeads,
    fields: [
      { type: "date_range", name: "leadStatusChangedOn" },
      {
        type: "dropdown",
        name: "leadSourceId",
        label: "Select Lead Source",
        options: "leadSourceId",
      },
    ],
    image: `/assets/app-images/chart-images/1.png`,
  },
  [ReportEnums.Leads_contacted_by_team_member]: {
    categoryIds: [1],
    query: Get_Leads_Contacted_By_Team_Member,
    dataKey: "leadsContactedByTeamMemberReport",
    name: "Leads Contacted By Team Members",
    desc: "Bar Chart - Team member vs leads",
    isKPI: false,
    type: Chart_Types.bar_h_single,
    graphInfo: {
      graphDataMapper: (data, users) => {
        let obj = {};
        data.forEach((e) => {
          obj = {
            ...obj,
            [e.teamMemberId]: data.filter(
              (a) => a.teamMemberId == e.teamMemberId
            ).length,
          };
        });

        return {
          labels: Object.keys(obj).map((k) => {
            return (
              users.find((f) => f.id == Number(k))?.displayName || "others"
            );
          }),
          values: Object.values(obj),
          color: Object.keys(obj).map(
            (k) => users.find((f) => f.id == Number(k))?.color || GraphColors[5]
          ),
        };
      },
      xLabel: "Number of leads",
      yLabel: "Team members",
      staticFilters: [{ teamMemberId: { neq: -2 } }],
      // singleColor: colorEnums.darkBlue.text,
    },
    fields: [
      { type: "date_range", name: "overTime" },
      {
        type: "dropdown",
        name: "leadSourceId",
        label: "Select Lead Source",
        options: "leadSourceId",
      },
      {
        type: "dropdown",
        name: "leadStatusId",
        label: "Select Lead Status",
        options: "leadStatusId",
      },
      {
        type: "checkbox",
        name: "teamMemberId",
        options: "leadContactedUsers",
      },
    ],
    image: `/assets/app-images/chart-images/2.png`,
  },
  [ReportEnums.Leads_generated]: {
    categoryIds: [1],
    query: Get_Leads_Generated,
    dataKey: "leadsGeneratedReport",
    name: "Leads Generated",
    desc: "KPI",
    isKPI: true,
    gridType: "duration",
    type: Chart_Types.widget,
    fields: [
      { type: "date_range", name: "createdOn" },
      {
        type: "dropdown",
        name: "leadSourceId",
        label: "Select Lead Source",
        options: "leadSourceId",
      },
    ],
    columns: [
      {
        title: "Lead Generated",
        name: "count",
      },
      {
        name: "overTime",
        title: "Over Time",
      },
    ],
  },
  [ReportEnums.MQL_leads_by_first_outreach]: {
    categoryIds: [1],
    query: Get_Mql_Leads_By_First_Outreach,
    dataKey: "mqlLeadsByFirstOutreachReport",
    name: "MQL Leads By First Outreach",
    desc: "KPI",
    isKPI: true,
    paramKey: "overTime",
    type: Chart_Types.widget,
    fields: [
      { type: "date_range", name: "overTime" },
      {
        type: "dropdown",
        name: "leadSourceId",
        label: "Select Lead Source",
        options: "leadSourceId",
      },
      {
        type: "location-comp",
        name: "leadLocation",
        label: "Select Lead Location",
        options: "stateProvinceId",
      },
      {
        type: "checkbox",
        name: "teamMemberId",
      },
    ],
    columns: [
      {
        title: "Qualified Leads",
        name: "qualifiedLead",
      },
      {
        title: "Over Time",
        name: "overTime",
        render: (data) => getFormattedDate(data?.overTime, "DD MMM, YYYY"),
      },
    ],
  },
  [ReportEnums.Leads_by_location]: {
    categoryIds: [1],
    query: Get_Leads_By_Location,
    dataKey: "leadsByLocationReport",
    name: "Leads By Location",
    desc: "Bar chart - Leads by country/city/state",
    isKPI: false,
    type: Chart_Types.bar_h_single,

    graphInfo: {
      checkBoxOptionsKey: "StateProvinceId",
      graphDataMapper: (data, states = []) => {
        let sets = groupBy(data, "stateProvinceId");

        let temp = Object.keys(sets)
          .map((element) => ({
            value: sets[element].reduce((acc, cur) => acc + cur.leadCount, 0),
            label: !!Number(element)
              ? states.find((s) => s.stateProvinceId == Number(element))
                  ?.stateProvinceName
              : element,
          }))
          .sort((a, b) => b.value - a.value);

        return {
          labels: temp.map((t) => t.label),
          values: temp.map((t) => t.value),
        };
      },
      xLabel: "Leads",
      yLabel: "Countries",
      // singleColor: colorEnums.darkBlue.text,
    },
    fields: [
      { type: "date_range", name: "leadCreatedOnDateOnly" },
      {
        type: "dropdown",
        name: "leadSourceId",
        label: "Select Lead Source",
        options: "leadSourceId",
      },
      {
        type: "location-comp",
        name: "leadLocation",
        label: "Select Lead Location",
        options: "stateProvinceId",
      },
    ],
  },
  [ReportEnums.Leads_not_contacted]: {
    categoryIds: [1],
    query: Get_Leads_Not_Contacted,
    dataKey: "leadsNotContactedReport",
    defaultSortKey: "leadId",
    name: "Leads Not Contacted",
    desc: "Data Table - Lead name, assigned to, Date of lead generation",
    isKPI: false,
    type: Chart_Types.grid,
    columns: LeadsNotContactedColumns,
    image: `/assets/app-images/chart-images/1.png`,
    fields: [
      { type: "date_range", name: "dateOfLeadGeneration" },
      {
        type: "dropdown",
        name: "leadSourceId",
        label: "Select Lead Source",
        options: "leadSourceId",
      },
      {
        type: "dropdown",
        name: "assignedTo",
        label: "Select Assignee",
        options: "assignedTo",
      },
    ],
  },
  [ReportEnums.Leads_lost]: {
    categoryIds: [1],
    query: "",
    dataKey: "",
    name: "Leads Lost",
    desc: "Line chart - Leads lost per time",
    isKPI: false,
    type: "",
  },
  [ReportEnums.Avg_lead_response_time]: {
    categoryIds: [1],
    query: Get_Avg_Lead_Response_Time,
    dataKey: "avgLeadResponseTimeReport",
    name: "Avg Lead Response Time",
    desc: "Line chart - Avg lead response time by team",
    isKPI: false,
    type: Chart_Types.line_multiple,
    image: `/assets/app-images/chart-images/8.png`,
    graphInfo: {
      graphDataMapper: (data, users, filters) => {
        // Step 1: Create a map of user IDs to user display names
        const userMap = {};
        users.forEach((user) => {
          userMap[user.id] = { color: user.color, name: user.displayName };
        });

        // Step 2: Create an array for labels (unique dates) and a map to store the counts by user
        const labelsSet = new Set();
        const valuesMap = {};

        // Step 3: Populate labelsSet and valuesMap
        // labelsSet.add(date);
        data.forEach((entry) => {
          const date = (entry?.firstOutreachTime || "").split("T")[0]; // Extract the date part
          const leadOwnerId = entry?.leadOwnerId;

          labelsSet.add(date);

          if (!valuesMap[leadOwnerId]) {
            valuesMap[leadOwnerId] = {};
          }

          if (!valuesMap[leadOwnerId][date]) {
            valuesMap[leadOwnerId][date] = [];
          }

          valuesMap[leadOwnerId][date].push(entry);
        });

        AddDatesToSet(labelsSet, "firstOutreachTime", filters);

        // Convert labelsSet to an array and sort it
        const labels = Array.from(labelsSet).sort();

        // Step 4: Convert the valuesMap to the desired format with missing dates filled with 0
        const values = Object.keys(valuesMap).map((ownerId, index) => {
          return {
            label: userMap[ownerId]?.name || "",
            values: labels.map((label) => {
              let temp = {};
              if (valuesMap[ownerId][label])
                temp = valuesMap[ownerId][label].reduce((acc, crr) => {
                  return {
                    avgResponseTimeMinutes:
                      acc?.avgResponseTimeMinutes + crr?.avgResponseTimeMinutes,
                    totalLeads: acc?.totalLeads + crr?.totalLeads,
                  };
                });
              let avg = Math.ceil(
                temp?.avgResponseTimeMinutes / temp?.totalLeads
              );

              return avg || 0;
            }),
            color: userMap[ownerId]?.color || GraphColors[0],
          };
        });
        return { labels, values };
      },
      xLabel: "date_range",
      yLabel: "Duration (mins)",
    },
    icon: "lineChart",
    fields: [
      { type: "date_range", name: "firstOutreachTime" },
      {
        type: "dropdown",
        name: "leadStatusId",
        label: "Select Lead Status",
        options: "leadStatusId",
      },
      {
        type: "checkbox",
        name: "leadOwnerId",
        title: "Owners",
      },
    ],
  },
  [ReportEnums.Lead_lists_in_workflows]: {
    categoryIds: [2, 6],
    query: Get_Lead_Lists_In_Workflows,
    dataKey: "leadListsInWorkflowsReport",
    name: "Lead Lists In Automations",
    desc: "Data Table - List name, created by, Created on, automation used in",
    isKPI: false,
    defaultSortKey: false,
    type: Chart_Types.grid,
    image: `/assets/app-images/chart-images/1.png`,
    columns: LeadListInWorkflowsColumns,
    fields: [{ type: "date_range", name: "createdOn" }],
  },
  [ReportEnums.Top_10_lists]: {
    categoryIds: [2],
    query: "",
    dataKey: "",
    name: "Top 10 Lists",
    desc: "Horizontal bar chart - Top 10 lead list",
    isKPI: false,
    type: Chart_Types.bar_h_single,
  },
  [ReportEnums.Avg_email_open_rate]: {
    categoryIds: [3],
    query: Get_Avg_Email_Open_Rate,
    dataKey: "avgEmailOpenRateReport",
    name: "Avg Email Open Rate",
    desc: "Line chart - email open per day",
    isKPI: false,
    type: Chart_Types.line_single,
    image: `/assets/app-images/chart-images/13.png`,
    graphInfo: {
      graphDataMapper: (data, users, filters) => {
        // Step 1: Create a map of user IDs to user display names
        // let temp = [...data];
        const userMap = {};
        users.forEach((user) => {
          userMap[user.id] = { color: user.color, name: user.displayName };
        });
        // Step 2: Create an array for labels (unique dates) and a map to store the counts by date
        const labelsSet = new Set();

        const countsByDate = {};
        let temp = data.filter((d) => d.openRate);
        // Step 3: Populate labelsSet and countsByDate
        temp.forEach((entry) => {
          const date = entry?.emailSentDate?.split("T")[0]; // Extract the date part
          labelsSet.add(date);

          if (!countsByDate[date]) {
            countsByDate[date] = [];
          }
          countsByDate[date].push(entry?.openRate);
        });

        AddDatesToSet(labelsSet, "emailSentDate", filters);

        let valueObj = {};
        Object.keys(countsByDate).forEach((key) => {
          let count = countsByDate[key].reduce((acc, cur) => acc + cur, 0);
          valueObj[key] = count / countsByDate[key].length;
        });

        // Convert labelsSet to an array and sort it
        const labels = Array.from(labelsSet).sort();

        // Step 4: Create the values array with counts for each date
        const values = labels.map((label) => Math.ceil(valueObj[label] || 0));

        return { labels, values };
      },
      xLabel: "date_range",
      yLabel: "Email open rate",
      staticFilters: [{ openRate: { neq: 0 } }],
      unit: "%",
      color: GraphColors[3],
    },
    fields: [
      { type: "date_range", name: "emailSentDate" },
      // {
      //   type: "api-dropdown",
      //   name: "leadId",
      //   label: "Lead Name",
      //   options: "leadName",
      // },
      {
        type: "dropdown",
        name: "leadSourceId",
        label: "Select Lead Source",
        options: "leadSourceId",
      },
      {
        type: "dropdown",
        name: "industryId",
        label: "Select Industry",
        options: "industries",
      },
      {
        type: "location-comp",
        name: "leadLocation",
        label: "Select Lead Location",
        options: "stateProvinceId",
      },
    ],
  },
  [ReportEnums.Email_conversations_over_time]: {
    categoryIds: [3],
    query: Get_Email_Conversations_OverTime,
    dataKey: "emailConversationsOverTime",
    name: "Email Conversations Over Time",
    desc: "Line chart - emails per time",
    isKPI: false,
    type: Chart_Types.line_multiple,
    image: `/assets/app-images/chart-images/13.png`,
    graphInfo: {
      graphDataMapper: (data, users, filters) => {
        const userMap = {};
        users.forEach((user) => {
          userMap[user.id] = { color: user.color, name: user.displayName };
        });

        // Step 2: Create an array for labels (unique dates) and a map to store the counts by user
        const labelsSet = new Set();
        const valuesMap = {};

        // Step 3: Populate labelsSet and valuesMap
        data.forEach((entry) => {
          const date = (entry?.emailSentDate || "").split("T")[0]; // Extract the date part
          const leadOwnerId = entry?.teamMemberId;

          labelsSet.add(date);

          if (!valuesMap[leadOwnerId]) {
            valuesMap[leadOwnerId] = {};
          }

          if (!valuesMap[leadOwnerId][date]) {
            valuesMap[leadOwnerId][date] = 0;
          }

          valuesMap[leadOwnerId][date] += 1;
        });

        AddDatesToSet(labelsSet, "emailSentDate", filters);

        // Convert labelsSet to an array and sort it
        const labels = Array.from(labelsSet).sort();

        // Step 4: Convert the valuesMap to the desired format with missing dates filled with 0
        const values = Object.keys(valuesMap).map((leadOwnerId, index) => {
          return {
            label: userMap[leadOwnerId]?.name || "",
            values: labels.map((label) => valuesMap[leadOwnerId][label] || 0),
            color: userMap[leadOwnerId]?.color,
          };
        });
        return { labels, values };
      },
      xLabel: "date_range",
      yLabel: "Conversations",
      color: GraphColors[0],
    },
    icon: "lineChart",
    fields: [
      { type: "date_range", name: "emailSentDate" },
      // {
      //   type: "api-dropdown",
      //   name: "leadId",
      //   label: "Lead Name",
      //   options: "leadName",
      // },
      {
        type: "dropdown",
        name: "leadSourceId",
        label: "Select Lead Source",
        options: "leadSourceId",
      },
      {
        type: "checkbox",
        name: "teamMemberId",
      },
    ],
  },
  [ReportEnums.Email_un_subscribe_rate]: {
    categoryIds: [3],
    query: "",
    dataKey: "",
    name: "Email Un-subscribe Rate",
    desc: "Line chart - Users unsubscribing emails over time",
    isKPI: false,
    type: Chart_Types.line_single,
    image: `/assets/app-images/chart-images/13.png`,
  },
  [ReportEnums.Email_bounce_rate]: {
    categoryIds: [3],
    query: "",
    dataKey: "",
    name: "Email Bounce Rate",
    desc: "Line chart - Email bouncing over time",
    isKPI: false,
    type: Chart_Types.line_single,
  },
  [ReportEnums.SMS_Delivery_rate]: {
    categoryIds: [4],
    query: "",
    dataKey: "",
    name: "SMS Delivery Rate",
    desc: "KPI",
    isKPI: true,
    type: Chart_Types.widget,
  },
  [ReportEnums.SMS_Open_rate]: {
    categoryIds: [4],
    query: "",
    dataKey: "",
    name: "SMS Open Rate",
    desc: "KPI",
    isKPI: true,
    type: Chart_Types.widget,
  },
  [ReportEnums.Link_clicks_in_SMS]: {
    categoryIds: [4],
    query: "",
    dataKey: "",
    name: "Link Clicks In SMS",
    desc: "Bar Chart - SMS link clicks by leads over time",
    isKPI: false,
    type: Chart_Types.bar_v_multiple,
    image: `/assets/app-images/chart-images/17.png`,
  },
  [ReportEnums.Appointment_sent]: {
    categoryIds: [5],
    query: "",
    dataKey: "",
    name: "Appointment Sent",
    desc: "Bar Chart - appointments from sales rep",
    isKPI: false,
    type: "",
  },
  [ReportEnums.Appointment_booked]: {
    categoryIds: [5],
    query: "",
    dataKey: "",
    name: "Appointment Booked",
    desc: "Bar Chart - appointments from sales rep",
    isKPI: false,
    type: Chart_Types.bar_v_multiple,
    image: `/assets/app-images/chart-images/19.png`,
  },
  [ReportEnums.Lead_to_appointment_ratio]: {
    categoryIds: [5],
    query: "",
    dataKey: "",
    name: "Lead To Appointment Ratio",
    desc: "Pie Chart",
    isKPI: false,
    type: Chart_Types.pie,
    image: `/assets/app-images/chart-images/chart-pie.png`,
    // image: `/assets/app-images/chart-images/20.png`,
  },
  [ReportEnums.Leads_with_social_platforms]: {
    categoryIds: [7],
    query: "",
    dataKey: "",
    name: "Leads With Social Platforms",
    desc: "Data Table - Lead name, created by (Facebook/ Twitter/ LinkedIn)",
    isKPI: false,
    type: "",
  },
  [ReportEnums.Email_received]: {
    categoryIds: [3],
    query: Get_Email_Received,
    dataKey: "emailReceivedReport",
    name: "Email Received",
    desc: "KPI",
    isKPI: true,
    type: Chart_Types.widget,
    fields: [
      { type: "date_range", name: "createdOn" },
      {
        type: "dropdown",
        name: "leadSourceId",
        label: "Select Lead Source",
        options: "leadSourceId",
      },
      {
        type: "location-comp",
        name: "leadLocation",
        label: "Select Lead Location",
        options: "stateProvinceId",
      },
    ],
    columns: [
      {
        title: "Lead Name",
        name: "leadName",
        render: (data) => (data["leadName"] || "").trim() || "N/A",
      },
      {
        title: "Email Address",
        name: "email",
      },
      {
        title: "Date",
        name: "createdOn",
        render: (data) => getFormattedDate(data?.createdOn, "DD/MM/YYYY"),
      },
    ],
  },
  [ReportEnums.Email_sent]: {
    categoryIds: [3],
    query: Get_Email_Sent,
    dataKey: "emailSentReport",
    name: "Email Sent",
    desc: "KPI",
    isKPI: true,
    type: Chart_Types.widget,
    fields: [
      { type: "date_range", name: "createdOn" },
      {
        type: "dropdown",
        name: "leadSourceId",
        label: "Select Lead Source",
        options: "leadSourceId",
      },
      {
        type: "location-comp",
        name: "leadLocation",
        label: "Select Lead Location",
        options: "stateProvinceId",
      },
    ],
    columns: [
      {
        title: "Lead Name",
        name: "leadName",
        render: (data) => data["leadName"].trim() || "N/A",
      },
      {
        title: "Email",
        name: "email",
      },
      {
        title: "Sent Date",
        name: "createdOn",
        render: (data) => getFormattedDate(data?.createdOn, "DD/MM/YYYY"),
      },
      {
        title: "Status",
        name: "isOpened",
        render: (data) => {
          return <Chip label={data?.isOpened ? "Opened" : "Not Opened"} />;
        },
      },
    ],
  },
  [ReportEnums.SMS_sent]: {
    categoryIds: [4],
    query: Get_SMS_Sent,
    dataKey: "smsSentReport",
    name: "SMS Sent",
    desc: "KPI",
    isKPI: true,
    type: Chart_Types.widget,
    fields: [
      { type: "date_range", name: "createdOn" },
      {
        type: "dropdown",
        name: "leadSourceId",
        label: "Select Lead Source",
        options: "leadSourceId",
      },
      {
        type: "location-comp",
        name: "leadLocation",
        label: "Select Lead Location",
        options: "stateProvinceId",
      },
    ],
    columns: [
      {
        title: "Lead Name ",
        name: "leadName",
        render: (data) => data["leadName"].trim() || "N/A",
      },
      {
        title: "SMS Date",
        name: "createdOn",
        render: (data) => getFormattedDate(data?.createdOn, "DD/MM/YYYY"),
      },
      {
        title: "Status",
        name: "status",
        render: (data) => {
          return <Chip label={data?.status ? "Delivered" : "Not Delivered"} />;
        },
      },
    ],
  },
  [ReportEnums.SMS_received]: {
    categoryIds: [4],
    query: Get_SMS_Received,
    dataKey: "smsReceivedReport",
    name: "SMS Received",
    desc: "KPI",
    isKPI: true,
    type: Chart_Types.widget,
    fields: [
      { type: "date_range", name: "createdOn" },
      {
        type: "dropdown",
        name: "leadSourceId",
        label: "Select Lead Source",
        options: "leadSourceId",
      },
      {
        type: "location-comp",
        name: "leadLocation",
        label: "Select Lead Location",
        options: "stateProvinceId",
      },
    ],
    columns: [
      {
        title: "Lead Name ",
        name: "leadName",
        render: (data) => data["leadName"].trim() || "N/A",
      },
      {
        title: "SMS Date",
        name: "createdOn",
        render: (data) => getFormattedDate(data?.createdOn, "DD MMM, YYYY"),
      },
    ],
  },
  [ReportEnums.Appointment_Scheduled]: {
    categoryIds: [5],
    query: Get_Appointment_Scheduled,
    dataKey: "appointmentScheduledReport",
    name: "Appointment Scheduled",
    desc: "KPI",
    isKPI: true,
    type: Chart_Types.widget,
    fields: [
      { type: "date_range", name: "createdOn" },
      {
        type: "dropdown",
        name: "leadSourceId",
        label: "Select Lead Source",
        options: "leadSourceId",
      },
      {
        type: "location-comp",
        name: "leadLocation",
        label: "Select Lead Location",
        options: "stateProvinceId",
      },
      {
        type: "checkbox",
        name: "memberId",
        options: "memberId",
        // title: "Team",
      },
    ],
    columns: [
      {
        title: "Appointment Title",
        name: "title",
        //  render: (data) => data["leadName"].trim() || "N/A",
      },
      {
        title: "Lead Name",
        name: "leadName",
        // render: (data) => data["leadName"].trim() || "N/A",
      },
      {
        title: "Created By",
        name: "createdBy",
        // render: (data) => data["leadName"].trim() || "N/A",
      },
      {
        title: "Date Created",
        name: "createdOn",
        render: (data) =>
          getFormattedDate(data?.createdOn, "DD MMM, YYYY", false),
      },
      {
        title: "Appointment Date",
        name: "startDate",
        render: (data) =>
          getFormattedDate(data?.createdOn, "DD MMM, YYYY", false),
      },
      {
        title: "Appointment Time",
        name: "startDate",
        width: "300px",
        render: (data) =>
          `${getFormattedDate(data?.startDate, "hh:mm A", false)} - ${getFormattedDate(data?.endDate, "hh:mm A", false)} ${getTimezoneAbbreviation()}`,
      },
    ],
  },
  [ReportEnums.Unassigned_leads]: {
    categoryIds: [1],
    query: Get_Unassigned_Leads,
    dataKey: "unassignedLeadsReport",
    name: "Unassigned Leads",
    desc: "Data Table - Lead, Create date",
    isKPI: false,
    type: Chart_Types.grid,
    columns: UnassignedLeadsColumns,
    fields: [{ type: "date_range", name: "createdOn" }],
  },
  [ReportEnums.Active_Workflows_Activity_Report]: {
    categoryIds: [6],
    query: Get_Active_Workflows_Activity,
    dataKey: "activeWorkflowsActivityReport",
    name: "Active Automations Activity",
    desc: "Line chart - Timely activity of email and sms sent",
    isKPI: false,
    type: Chart_Types.line_multiple,
    image: `/assets/app-images/chart-images/8.png`,
    graphInfo: {
      graphDataMapper: (data, workflows, filters) => {
        // Step 1: Create a map of user IDs to user display names
        const flows = {};
        workflows.forEach((workflow) => {
          flows[workflow.id] = {
            color: workflow.color,
            name: workflow.displayName,
          };
        });

        // Step 2: Create an array for labels (unique dates) and a map to store the counts by date
        const labelsSet = new Set();
        const countsByDate = [];

        // Step 3: Populate labelsSet and countsByDate
        data.forEach((entry) => {
          const date = entry.activityDate?.split("T")[0]; // Extract the date part

          labelsSet.add(date);

          // if (!countsByDate[date]) {
          //   countsByDate[date] = 0;
          // }

          // countsByDate[date] += 1;
        });

        AddDatesToSet(labelsSet, "activityDate", filters);

        // Convert labelsSet to an array and sort it
        const labels = Array.from(labelsSet).sort();
        let sets = groupBy(data, "workFlowId");

        Object.keys(sets).forEach((set) => {
          let tempValues = labels.map((l) => {
            let temp = sets[set].filter(
              (f) => f.activityDate?.split("T")[0] == l
            );
            let arr = [];

            Object.values(ActivityTypeEnumns).forEach((a) => {
              let count = temp
                .filter((t) => t.activityTypeId == a)
                .reduce((acc, section) => acc + section?.leadCount || 0, 0);
              arr.push(count);
            });
            let value = arr.reduce((acc, section) => acc + section || 0, 0);

            arr.splice(0, 0, value);
            return arr;
          });

          countsByDate.push({
            label: flows[set]?.name || "",
            values: tempValues,
            color: flows[set]?.color,
          });
        });
        // Step 4: Create the values array with counts for each date
        const values = [...countsByDate];

        return { labels, values };
      },
      checkBoxOptionsKey: "workflows",
      xLabel: "date_range",
      yLabel: "Activities",
      customTooltip: ({ values }) => ({
        label: ({ dataIndex, datasetIndex, dataset }) => {
          let data = values[datasetIndex]?.values[dataIndex];
          let otherLabels = [];
          Object.keys(ActivityTypeEnumns).forEach((key, index) => {
            if (data[index + 1])
              otherLabels.push(`${key} : ${data[index + 1]}`);
          });
          let label = dataset.label || "Activity";
          return [`  ${label} : ${data[0]}`, ...otherLabels];
        },
      }),
    },
    fields: [
      { type: "date_range", name: "activityDate" },
      {
        type: "dropdown",
        name: "activityTypeId",
        label: "Select Response Type",
        options: [
          /* Enum used from activityType email received, and sms recevied */
          { label: "SMS", value: 1 },
          { label: "Email", value: 2 },
        ],
      },
      {
        title: "Automations",
        type: "checkbox",
        name: "workFlowId",
        options: "workflows",
      },
    ],
  },
  [ReportEnums.Active_Workflows_With_Leads_Report]: {
    categoryIds: [6],
    query: Get_Active_Workflow_With_Leads,
    dataKey: "activeWorkflowsWithLeadsReport",
    name: "Active Automations With Leads",
    desc: "Data Table - Number of leads enrolled",
    isKPI: false,
    type: Chart_Types.grid,
    columns: ActiveWorkflowsWithLeadsColumns,
    image: `/assets/app-images/chart-images/1.png`,
    fields: [
      { type: "date_range", name: "workflowCreatedOn" },
      {
        type: "slider",
        name: "numberOfLeadsEnrolled",
      },
    ],
  },
};

const AddDatesToSet = (set, key, filters) => {
  let data = filters?.[key];
  if (data) {
    let start = moment(data.startDate).format("YYYY-MM-DD");
    let end = moment(data.endDate).format("YYYY-MM-DD");
    set.add(start);
    set.add(end);
  }
};

export const AvailableTemplatesIds = Object.keys(ReportTemplatesInfo)
  .filter((k) => ReportTemplatesInfo[k].query)
  .map((m) => Number(m));
